import { connectInput } from 'lib/form';
import { PhoneNumberInput } from '../common';

const PhoneNumberField = connectInput(PhoneNumberInput, {
  onChangeArgType: 'raw-value',
});

export default PhoneNumberField;
